import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class MonitoringToolInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let monitoringTool = window.monitoringTool;
    const modifiedRequest = monitoringTool
      ? request.clone({ setHeaders: { 'Monitoring-Tool': monitoringTool } })
      : request;

    return next.handle(modifiedRequest);
  }
}
